import $ from 'jquery';
import braintreeClient from 'braintree-web/client';
import braintreeDataCollector from 'braintree-web/data-collector';
import braintreePaypalCheckout from 'braintree-web/paypal-checkout';

import AlerterView from 'chairisher/view/alerter';

import { getBraintreeConnectionError } from 'chairisher/context/error';
import { isPaypalEnabled } from 'chairisher/context/payment';
import { getPaypalRestId } from 'chairisher/context/purchase';
import { logError } from 'chairisher/util/analytics';

let hasPushedBraintreeError = false;

function onError(error) {
    if (error) {
        logError('braintree initialize error', error);
    }

    // remove any braintree linkage delete links
    $('.js-braintree-delete').remove();

    if (!hasPushedBraintreeError) {
        AlerterView.error(getBraintreeConnectionError());
        hasPushedBraintreeError = true;
    }
}

let paypalPromise = null;

/**
 * Loads braintree libraries and applies provided config and callbacks.
 *
 * @param {object} config
 * @param {string} config.braintreeToken
 * @param {function} config.onFail
 * @param {function} config.setDeviceData
 * @param {function} config.checkoutCallback
 * @returns {Promise}
 */
export async function initializeBraintree(config) {
    if (isPaypalEnabled()) {
        try {
            const clientInstance = await braintreeClient.create({ authorization: config.braintreeToken });

            const [dataCollectorInstance, paypalCheckoutInstance] = await Promise.all([
                braintreeDataCollector.create({
                    client: clientInstance,
                    paypal: true,
                }),
                braintreePaypalCheckout.create({ client: clientInstance }),
            ]);

            if (config.setDeviceData) {
                config.setDeviceData(JSON.parse(dataCollectorInstance.deviceData));
            }

            if (paypalPromise === null) {
                // this causes issues when loaded more than once
                paypalPromise = paypalCheckoutInstance.loadPayPalSDK({
                    'client-id': getPaypalRestId(),
                    'disable-funding': 'card',
                    'vault': true,
                });
            }

            await paypalPromise; // window.paypal is available after promise resolves

            config.checkoutCallback(window.paypal, paypalCheckoutInstance);
        } catch (error) {
            onError(error);
            config.onFail();
        }
    }
}

/**
 * @param {Object} payload The full object that is passed back from a PayPal express checkout.
 * @returns {Object} An object that can be set to purchaseData.shipto_address.
 */
export function makeChairishShiptoAddress(payload) {
    const { shippingAddress } = payload.details;
    return {
        city: { value: shippingAddress.city },
        country_code: { value: shippingAddress.countryCode },
        name: { value: shippingAddress.recipientName },
        phone_number: { value: payload.details.phone },
        postal_code: { value: shippingAddress.postalCode },
        state: { value: shippingAddress.state },
        street_address_line_1: { value: shippingAddress.line1 },
        street_address_line_2: { value: shippingAddress.line2 },
    };
}
